
export type ReportPart = 'template' | 'accounts' | 'notes' | 'aop' | 'cashflow' | 'ems' | 'complementary';

const REPORT_PARTS: ReportPart[] = ['template', 'accounts', 'notes', 'aop', 'cashflow', 'ems', 'complementary'];

export class UntranslatedTexts {
    private readonly textsByPart = new Map<ReportPart, Set<string>>();

    constructor() {
        this.reset();
    }

    
    reset(): void {
        REPORT_PARTS.forEach((part) => this.textsByPart.set(part, new Set<string>()));
    }

    add(part: ReportPart, text: string): void {
        this.textsByPart.get(part).add(text);
    }

    of(part: ReportPart): Set<string> {
        return this.textsByPart.get(part);
    }

   
    all(): Set<string> {
        const allTexts = new Set<string>();
        this.textsByPart.forEach((texts) => texts.forEach((text) => allTexts.add(text)));

        return allTexts;
    }
}
